import React, { Component } from 'react';
import Key from '../Key';

var Keyboard = React.createClass({

  handleClick: function(data){
    if(this.props.regexp.test(data) && this.props.autoNext){
      this.props.actionDoneNext(data);
      return;
    }
    this.props.actionSaveField(data);
  },
  render: function(){
    if (!this.props.mobile) {
      if(this.props.advertisingSites && this.props.advertisingSites.length){
        return (
          <div className="keyboardWrapper">
            <div className="Keyboard letters bigButton infoAbout">
              {this.props.advertisingSites.map(function(item){
                return (
                  <Key actionClickButton={function(){
                    this.handleClick(item.id)
                  }.bind(this)} val={item.name} />
                )
              }.bind(this))}
            </div>
          </div>
        )
      }
      return(
        <div className="keyboardWrapper">
          <div className="Keyboard letters bigButton infoAbout">
            <Key actionClickButton={this.handleClick} val="OK" />
            <Key actionClickButton={this.handleClick} val="HeadHunter" />
            <Key actionClickButton={this.handleClick} val="Yandex" />
            <Key actionClickButton={this.handleClick} val="job.ru" />
            <Key actionClickButton={this.handleClick} val="career.ru" />
            <Key actionClickButton={this.handleClick} val="SuperJob" />
            <Key actionClickButton={this.handleClick} val="Работа.ru" />
            <Key actionClickButton={this.handleClick} val="job-mo.ru" />
            <Key actionClickButton={this.handleClick} val="rabota.mail.ru" />
            <Key actionClickButton={this.handleClick} val="job50.ru" />
            <Key actionClickButton={this.handleClick} val="jobs.ru" />
            <Key actionClickButton={this.handleClick} val="indeed.com" />
            <Key actionClickButton={this.handleClick} val="vk.ru" />
            <Key actionClickButton={this.handleClick} val="careerist.ru" />
            <Key actionClickButton={this.handleClick} val="zarplata.ru" />
            <Key actionClickButton={this.handleClick} val="irr.ru" />
            <Key actionClickButton={this.handleClick} val="JobLab.ru" />
            <Key actionClickButton={this.handleClick} val="rabota.ru" />
            <Key actionClickButton={this.handleClick} val="Mister Mario" />
            <Key actionClickButton={this.handleClick} val="Avito.ru" />
          </div>
        </div>
      );
    }else{if(this.props.advertisingSites && this.props.advertisingSites.length){
      return (
        <div className="keyboardWrapper Numbers">
          <div>
          <div className="Keyboard numbers padding" style={{position: 'absolute', height: 1600, background: '#f1f1f1'}}>
            {this.props.advertisingSites.map(function(item){
              return (
                <div className="row">
                  <Key mobile={this.props.mobile} actionClickButton={function(){
                    this.handleClick(item.id)
                  }.bind(this)} val={item.name} />
                </div>
              )
            }.bind(this))}
            </div>
          </div>
        </div>
      )
    }
      return(
        <div className="keyboardWrapper Numbers">
          <div>
          <div className="Keyboard numbers padding" style={{position: 'absolute', height: 1600, background: '#f1f1f1'}}>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="OK" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="HeadHunter" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="Yandex" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="SuperJob" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="Работа.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="Avito" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="job.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="career.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="job-mo.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="rabota.mail.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="job50.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="jobs.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="indeed.com" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="vk.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="careerist.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="zarplata.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="rabota.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="irr.ru" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="JobLab.ru" />
              </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="Mister Mario" />
            </div>
            <div className="row">
              <Key mobile={this.props.mobile} actionClickButton={this.handleClick} val="Pechkin" />
            </div>
          </div>
          </div>
        </div>
      );
    }

  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/InfoAbout/index.jsx
 **/